export default "__VITE_ASSET__WKIyDpKI__"